import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import {
  materialClassSchema,
  materialFamilySchema,
  materialSchema,
  supplierMaterialSchema,
} from './entities';

export const types = {
  INIT_BEGIN: 'materials/INIT_BEGIN',
  INIT_FAILURE: 'materials/INIT_FAILURE',
  INIT_SUCCESS: 'materials/INIT_SUCCESS',
  INIT_MATERIAL_STORE: 'materials/INIT_MATERIAL_STORE',
  RECEIVE_CLASSES: 'materials/RECEIVE_CLASSES',
  RECEIVE_FAMILIES: 'materials/RECEIVE_FAMILIES',
  RECEIVE_MATERIALS: 'materials/RECEIVE_MATERIALS',
  RECEIVE_MATERIAL_SELECTOR_SETTINGS:
    'materials/RECEIVE_MATERIAL_SELECTOR_SETTINGS',
  RECEIVE_SUPPLIER_MATERIALS: 'materials/RECEIVE_SUPPLIER_MATERIALS',
  RECEIVE_SUPPLIER_MATERIAL_FROM_GET_OR_CREATE:
    'materials/RECEIVE_SUPPLIER_MATERIAL_FROM_GET_OR_CREATE',
  RECEIVE_STORED_MATERIAL_OPTIONS_FOR_CASCADER:
    'materials/RECEIVE_STORED_MATERIAL_OPTIONS_FOR_CASCADER',
  REMOVE_SUPPLIER_MATERIAL: 'materials/REMOVE_SUPPLIER_MATERIAL',
  UPDATE_STORED_MATERIAL_OPTIONS_FOR_CASCADER:
    'materials/UPDATE_STORED_MATERIAL_OPTIONS_FOR_CASCADER',
};

export const receiveClasses = (payload) => ({
  type: types.RECEIVE_CLASSES,
  payload: normalize(payload, [materialClassSchema]),
});

export const receiveFamilies = (payload) => ({
  type: types.RECEIVE_FAMILIES,
  payload: normalize(payload, [materialFamilySchema]),
});

export const receiveMaterials = (payload) => ({
  type: types.RECEIVE_MATERIALS,
  payload: normalize(payload, [materialSchema]),
});

export const receiveSupplierMaterials = (payload) => ({
  type: types.RECEIVE_SUPPLIER_MATERIALS,
  payload: normalize(payload, [supplierMaterialSchema]),
});

export const receiveMaterialSelectorSettings = ({ selectorSettings }) => ({
  type: types.RECEIVE_MATERIAL_SELECTOR_SETTINGS,
  payload: { selectorSettings },
});

export const receiveSupplierMaterialFromGetOrCreate = ({
  supplierMaterial,
}) => ({
  type: types.RECEIVE_SUPPLIER_MATERIAL_FROM_GET_OR_CREATE,
  payload: normalize(supplierMaterial, supplierMaterialSchema),
});

export const receiveStoredMaterialOptionsForCascader = ({
  excludedMaterialsById,
  materialOptionsForCascader,
}) => ({
  type: types.RECEIVE_STORED_MATERIAL_OPTIONS_FOR_CASCADER,
  payload: { excludedMaterialsById, materialOptionsForCascader },
});

export const removeSupplierMaterial = ({ supplierMaterialId }) => ({
  type: types.REMOVE_SUPPLIER_MATERIAL,
  payload: { supplierMaterialId },
});

export const updateStoredMaterialOptionsForCascader = () => ({
  type: types.UPDATE_STORED_MATERIAL_OPTIONS_FOR_CASCADER,
});

export const initMaterialsStore = () => ({
  type: types.INIT_MATERIAL_STORE,
});

export const init = {
  begin: () => ({
    type: types.INIT_BEGIN,
  }),
  success: () => ({
    type: types.INIT_SUCCESS,
  }),
  failure: notify(
    (error) => ({
      type: types.INIT_FAILURE,
      payload: error,
    }),
    "Can't fetch material information",
  ),
};
